import React from 'react';
import classNames from 'classnames';
import { injectIntl, intlShape } from 'react-intl';
import { find, path, pathOr } from 'ramda';

import { txIsEnquired } from '../../util/transactions';
import { getBookingDate, moment } from '../../util/dates';
import { LINE_ITEM_IS_BOOKING_FULL_DAY, propTypes } from '../../util/types';

import css from './BookingTimeInfo.css';

const BookingTimeInfoComponent = props => {
  const { bookingClassName, tx, intl } = props;
  const { booking } = tx;
  const isEnquiry = txIsEnquired(tx);
  const isEveningMode = pathOr(false, ['attributes', 'isEveningMode'], booking);
  const txProtectedData = isEnquiry && tx.attributes.protectedData;
  const isBookingFullDay = isEnquiry
    ? txProtectedData.isBookingFullDay
    : find(lineItem => lineItem.code === LINE_ITEM_IS_BOOKING_FULL_DAY, tx.attributes.lineItems);
  const dateWithTz = isEnquiry
    ? moment(txProtectedData.date)
    : path(['attributes', 'protectedData', 'bookingStartDisplay'], tx)
    ? moment(path(['attributes', 'protectedData', 'bookingStartDisplay'], tx))
    : moment(path(['attributes', 'start'], booking));
  const endDateWithTz = path(['attributes', 'protectedData', 'bookingEndDisplay'], tx)
    ? moment(path(['attributes', 'protectedData', 'bookingEndDisplay'], tx))
    : moment(path(['attributes', 'end'], booking));
  const dateFormatted = getBookingDate(intl, isBookingFullDay, dateWithTz, isEveningMode, endDateWithTz);

  return (
    <div className={classNames(css.bookingInfo, bookingClassName)}>
      <span className={css.dateSection}>{dateFormatted}</span>
    </div>
  );
};

BookingTimeInfoComponent.defaultProps = {};

BookingTimeInfoComponent.propTypes = {
  tx: propTypes.transaction.isRequired,

  intl: intlShape.isRequired,
};

const BookingTimeInfo = injectIntl(BookingTimeInfoComponent);

export default BookingTimeInfo;



// WEBPACK FOOTER //
// ./src/components/BookingTimeInfo/BookingTimeInfo.js